import React from 'react';
import { useRecoilState } from 'recoil';
import * as AppState from '../../../../AppState';
import MinMaxSelectInputs from '../../../Shared/MinMaxInputs/MinMaxSelectInputs';
import { optionItem } from '../../../Shared/MinMaxInputs/SelectInput/SelectInput';

const lotSizeOptions: optionItem[] = [
	{
		label: '1,000 sqft',
		value: 1000
	},
	{
		label: '2,000 sqft',
		value: 2000
	},
	{
		label: '3,000 sqft',
		value: 3000
	},
	{
		label: '4,000 sqft',
		value: 4000
	},
	{
		label: '5,000 sqft',
		value: 5000
	},
	{
		label: '7,500 sqft',
		value: 7500
	},
	{
		label: '1/4 acre',
		value: 10890
	},
	{
		label: '1/2 acre',
		value: 21780
	},
	{
		label: '1 acre',
		value: 43560
	},
	{
		label: '2 acres',
		value: 87120
	},
	{
		label: '5 acres',
		value: 217800
	},
	{
		label: '10 acres',
		value: 435600
	},
	{
		label: '20 acres',
		value: 871200
	},
	{
		label: '50 acres',
		value: 2178000
	},
	{
		label: '100 acres',
		value: 4356000
	}
];

export const mapGlobalValueToOption = (value: number, isMin: boolean): optionItem => {
	if (isMin && value === 0)
		return { label: 'No Min', value: 0 };
	if (!isMin && value === -1)
		return { label: 'No Max', value: -1 };

	const mappedLotSizeOption = lotSizeOptions.filter((option) => option.value === value)?.[0];

	if (mappedLotSizeOption === undefined)
		return isMin ? { label: 'No Min', value: 0 } : { label: 'No Max', value: 0 };

	return mappedLotSizeOption;
};

const LotSizeRange = () => {
	const [gsFilters, setGsFilters] = useRecoilState(AppState.gsFilters);

	const [minOption, setMinOption] = React.useState<optionItem>(mapGlobalValueToOption(gsFilters.lotSizeMin, true));
	const [maxOption, setMaxOption] = React.useState<optionItem>(mapGlobalValueToOption(gsFilters.lotSizeMax, false));

	// Handles filter reset
	React.useEffect(() => {
		setMinOption(mapGlobalValueToOption(gsFilters.lotSizeMin, true));
		setMaxOption(mapGlobalValueToOption(gsFilters.lotSizeMax, false));
	}, [gsFilters]);

	return (
		<>
			<MinMaxSelectInputs
				id='lotSizeFilter'
				callback={
					([min, max]) => setGsFilters(currVal => ({
						...currVal,
						lotSizeMin: min,
						lotSizeMax: max
					}))
				}
				wrapperClass='w-100'
				options={lotSizeOptions}
				minLabel='Lot size'
				minOption={minOption}
				globalMinValue={gsFilters.lotSizeMin}
				setMinOption={setMinOption}
				maxOption={maxOption}
				globalMaxValue={gsFilters.lotSizeMax}
				setMaxOption={setMaxOption} />
		</>
	);
};

export default LotSizeRange;
